// extracted by mini-css-extract-plugin
export default {"header":"header_header__cx+tp","logo":"header_logo__0EpAw","action":"header_action__h3eFZ","active":"header_active__67yJB"};